import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { TabsetComponent } from './tabset.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { TranslateModule } from '@ngx-translate/core'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'
import { TabComponent } from './tab/tab.component'

@NgModule({
  declarations: [TabsetComponent, TabComponent],
  imports: [
    TranslateModule,
    ContentEditableModule,
    CommonModule,
    FormsModule,
    TranslateModule,
    ContentEditableModule,
  ],
  exports: [TabsetComponent, TabComponent],
})
export class TabsetModule {}
